exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CreateAccountStep-1fa7c7ca{max-width:300px;text-align:center;margin:0 auto}\n", ""]);

// Exports
exports.locals = {
	"CreateAccountStep": "CreateAccountStep-1fa7c7ca"
};